import * as Yup from 'yup';

export default Yup.object().shape({
  taxSystem: Yup.mixed().required('SCHEMA_ERRORS.TAX_SYSTEM_REQUIRED')
});
